import { Tooltip, CartesianGrid, LineChart, Line, YAxis, XAxis, ResponsiveContainer, Legend } from 'recharts';

import CustomTooltip from './Tooltip';

const LineChartPie = ({ title, data, useData, showGrid, showYAxis, showXAxis }) => {
  return (
    <div style={{ width: '46%', backgroundColor: 'white', padding: 15, borderRadius: 10, boxShadow: '5px 5px 10px #dddddd' }}>
      <p style={{ marginTop: 0 }}>{title}</p>
      <div style={{ height: 300, width: '100%', marginTop: 20 }}>
        <ResponsiveContainer>
          <LineChart data={data} height={280}>
            {showGrid && <CartesianGrid stroke={'#dadada'} strokeWidth={1} vertical={false} />}
            {showYAxis && <YAxis axisLine={false} tickLine={false} />}
            {showXAxis && <XAxis dataKey={'name'} axisLine={false} tickLine={false} />}
            <Legend />
            <Tooltip cursor={false} content={(props) => <CustomTooltip {...props} useData={useData} />}/>
            {useData.map((ud, index) => (
              <Line name={ud.tooltipValue} type={'monotone'} key={index} dataKey={ud.key} stroke={ud.color} />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LineChartPie;
